// english

export default {
  configModel_title: '数据模型管理',
  configModel_group_title: '类别管理',
  configModel_group_list: '类别列表',
  configModel_item_edit_title: '编辑数据项',
  configModel_item_add_title: '添加数据项',
  configModel_item_fork_title: '派生数据项',

  // btn
  configModel_btn_add_item: '添加数据项',
  configModel_btn_add_group: '添加类别',
  configModel_btn_edit_group: '编辑类别',

  // table
  configModel_table_range: '值的范围',
  configModel_table_unit: '单位',
  configModel_table_group_name: '类别名称',

  // confirm
  configmModel_confirm_delete_title: '确定删除该项?',
  configmModel_confirm_delete_some_title: '确定删除这些项?',
  configmModel_confirm_delete_content: '选择IDs: {ids}',
  configmModel_confirm_delete_group: '确定删除该类别?',
  configmModel_confirm_delete_group_content: '类别名称: {name}',
  configmModel_confirm_delete_group_title: '确定删除该类别?',
  configmModel_confirm_delete_some_group_title: '确定删除这些类别?',
  configmModel_confirm_delete_group_content_ids: '类别IDs: {ids}',

  // form
  configModel_form_item_name: '数据项名称',
  configModel_form_item_name_placeholder: '请输入数据项名称',
  configModel_form_group_name: '类别名称',
  configModel_form_group_name_placeholder: '请选择一个类别',
  configModel_form_group_name_placeholder2: '请输入类别名称',
  configModel_form_item_type: '数据项类型',
  configModel_form_item_type_placeholder: '请选择一个类型',
  configModel_form_item_data_range: '数据范围',
  configModel_form_item_data_range_placeholder: '请输入数据范围',
  configModel_form_item_unit: '数据项单位',
  configModel_form_item_unit_placeholder: '请输入单位',
};
